import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { benefits } from '../data/content';
export function Benefits() {
  return <section className="bg-white py-14 sm:py-20" data-id="element-40" data-mp="4kfqaybzho4d">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-41" data-mp="4j4kksyza6am">
        <SectionHeading eyebrow="Il sistema" title="Sappi esattamente cosa fare quando un caso di TRT entra nel tuo studio" subtitle="Non ti serve un altro corso di 20 ore, né un’altra pila di articoli scollegati tra loro. Ti serve un sistema clinico chiaro che ti porti dalla valutazione al trattamento e al monitoraggio a lungo termine." data-id="element-42" data-mp="3vr0emaanmhxp" />

        <ol className="mt-10 space-y-4" data-id="element-43" data-mp="3cruqj0amrc8w">
          {benefits.map((benefit, i) => <li key={benefit.title} className="flex gap-4 border-l-2 border-gold-500 bg-navy-50/60 p-4 sm:p-5" data-id="element-44" data-mp="3ctz7aitmo5ql" data-mpi={i}>
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy-900 text-sm font-black text-gold-300" data-id="element-45" data-mp="1b1japjmijrdk">
                {i + 1}
              </span>
              <div data-id="element-46" data-mp="6t1itlxor76g">
                <h3 className="text-[15px] font-extrabold uppercase leading-snug tracking-tight text-navy-900 sm:text-lg" data-id="element-47" data-mp="6tkuwm0nn1ck">
                  {benefit.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-navy-900/70 sm:text-[15px]" data-id="element-48" data-mp="3twplszfflqs5">
                  {benefit.text}
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 flex justify-center" data-id="element-49" data-mp="qfqy8fcs7k8x">
          <CtaBlock label="Voglio il Sistema Maestro della TRT™" note="Accesso immediato · Pagamento unico · 19 EUR" data-id="element-50" data-mp="brw2eq3h8zrm" />
        </div>
      </div>
    </section>;
}